import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Spin, Row, Col, Checkbox, Input, Button, Select } from 'antd';
import { Animated } from "react-animated-css";

import { ResponsivePie } from '@nivo/pie'
import 'moment-timezone';

import CheckboxMenu from "./CheckboxMenu";

import './usermanagement.css';

import {
    userList,
    userDelete
} from '../../modules/user';
import {
    schoolList,
    averageScore
} from '../../modules/school';

import {
    groupList
} from '../../modules/group';

class DataHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addModal: false,
            selectedUser: null,
            schoolListData: null,
            schoolNameListData: ["all"],
            schoolYearList: [],
            classNameList: [],
            schoolIdListData: ["-1"],
            avgRScore: 0,
            avgIScore: 0,
            avgAScore: 0,
            avgSScore: 0,
            avgEScore: 0,
            avgCScore: 0,
            pieRData: [],
            pieIData: [],
            pieAData: [],
            pieSData: [],
            pieEData: [],
            pieCData: [],
            selectedSchool: [],
            selectedSchoolYear: [],
            selectedClassName: [],
            isLoading: true,
            RMaleCount: 0,
            RFemaleCount: 0,
            IMaleCount: 0,
            IFemaleCount: 0,
            AMaleCount: 0,
            AFemaleCount: 0,
            SMaleCount: 0,
            SFemaleCount: 0,
            EMaleCount: 0,
            EFemaleCount: 0,
            CMaleCount: 0,
            CFemaleCount: 0,
            totalCount: 0,
            selectedSchoolString: "",
            selectedYearString: "",
            selectedClassString: ""
        }
    }

    componentDidMount() {
        if (this.props.userData.length === 0) {
            this.props.userList();
        }
        this.getSchoolList();
        this.getGroup();
    }

    getAverageScore = (schoolId, schoolYear, name) => {

        this.props.averageScore(schoolId, schoolYear, name).then((res) => {

            if (res.averageRcore == null) {
                alert("找不到結果")
                this.setState({ isLoading: false })
                return;
            }

            this.setState({ avgRScore: res.averageRcore.toFixed(2) });
            this.setState({ avgIScore: res.averageIcore.toFixed(2) });
            this.setState({ avgAScore: res.averageAcore.toFixed(2) });
            this.setState({ avgSScore: res.averageScore.toFixed(2) });
            this.setState({ avgEScore: res.averageEcore.toFixed(2) });
            this.setState({ avgCScore: res.averageCcore.toFixed(2) });
            this.setState({ RMaleCount: res.RMaleCount });
            this.setState({ RFemaleCount: res.RFemaleCount });
            this.setState({ IMaleCount: res.IMaleCount });
            this.setState({ IFemaleCount: res.IFemaleCount });
            this.setState({ AMaleCount: res.AMaleCount });
            this.setState({ AFemaleCount: res.AFemaleCount });
            this.setState({ SMaleCount: res.SMaleCount });
            this.setState({ SFemaleCount: res.SFemaleCount });
            this.setState({ EMaleCount: res.EMaleCount });
            this.setState({ EFemaleCount: res.EFemaleCount });
            this.setState({ CMaleCount: res.CMaleCount });
            this.setState({ CFemaleCount: res.CFemaleCount });
            this.setState({ totalCount: res.totalDone });

            {
                var temp = [
                    {
                        "id": "M",
                        "label": "M",
                        "value": (100 * Math.round(res.RMalePercentage * 100) / 100).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    },
                    {
                        "id": "F",
                        "label": "F",
                        "value": (100 * (1 - Math.round(res.RMalePercentage * 100) / 100)).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    }
                ];
                this.setState({ pieRData: temp })
            }
            {
                var temp = [
                    {
                        "id": "M",
                        "label": "M",
                        "value": (100 * Math.round(res.IMalePercentage * 100) / 100).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    },
                    {
                        "id": "F",
                        "label": "F",
                        "value": (100 * (1 - Math.round(res.IMalePercentage * 100) / 100)).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    }
                ];
                this.setState({ pieIData: temp })
            }

            {
                var temp = [
                    {
                        "id": "M",
                        "label": "M",
                        "value": (100 * Math.round(res.AMalePercentage * 100) / 100).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    },
                    {
                        "id": "F",
                        "label": "F",
                        "value": (100 * (1 - Math.round(res.AMalePercentage * 100) / 100)).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    }
                ];
                this.setState({ pieAData: temp })
            }

            {
                var temp = [
                    {
                        "id": "M",
                        "label": "M",
                        "value": (100 * Math.round(res.SMalePercentage * 100) / 100).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    },
                    {
                        "id": "F",
                        "label": "F",
                        "value": (100 * (1 - Math.round(res.SMalePercentage * 100) / 100)).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    }
                ];
                this.setState({ pieSData: temp })
            }

            {
                var temp = [
                    {
                        "id": "M",
                        "label": "M",
                        "value": (100 * Math.round(res.EMalePercentage * 100) / 100).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    },
                    {
                        "id": "F",
                        "label": "F",
                        "value": (100 * (1 - Math.round(res.EMalePercentage * 100) / 100)).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    }
                ];
                this.setState({ pieEData: temp })
            }

            {
                var temp = [
                    {
                        "id": "M",
                        "label": "M",
                        "value": (100 * Math.round(res.CMalePercentage * 100) / 100).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    },
                    {
                        "id": "F",
                        "label": "F",
                        "value": (100 * (1 - Math.round(res.CMalePercentage * 100) / 100)).toFixed(0),
                        "color": "hsl(201, 70%, 50%)"
                    }
                ];
                this.setState({ pieCData: temp })
            }
            this.setState({ isLoading: false })
        })
    }

    getGroup() {
        this.props.groupList().then((res) => {
            var classYearDict = {
                "2026 - 2027": 1,
                "2025 - 2026": 1,
                "2024 - 2025": 1,
                "2023 - 2024": 1,
                "2022 - 2023": 1,
                "2021 - 2022": 1,
                "2020 - 2021": 1,
                "2019 - 2020": 1,
                "2018 - 2019": 1,
                "2017 - 2018": 1,
                "2016 - 2017": 1,
            };
            var classNameDict = {};
            var classYearArray = [];
            var classNameArray = [];
            for (var index in res.results) {
                // var classYear = res.results[index].schoolQuota.year;
                // classYearDict[classYear] = 1;
                var name = res.results[index].className;
                classNameDict[name] = 1;
            }
            for (var key in classYearDict) {
                classYearArray.push(key);
            }
            for (var key in classNameDict) {
                classNameArray.push(key);
            }
            this.setState({ schoolYearList: classYearArray });
            this.setState({ classNameList: classNameArray });
        })
    }

    getSchoolList = () => {
        this.props.schoolList().then((res) => {
            var tempSchoolNameListData = ["all"];
            var tempSchoolIdListData = ["-1"];
            for (var i = 0; i < res.results.length; i++) {
                tempSchoolNameListData.push(res.results[i].name_tc);
                tempSchoolIdListData.push(res.results[i]._id);
            }

            this.setState({ schoolNameListData: tempSchoolNameListData });
            this.setState({ schoolIdListData: tempSchoolIdListData });
            this.setState({ schoolListData: res });
            this.getAverageScore("", "", "");
        })
    }

    toggleAddModal = () => {
        const { addModal } = this.state;
        this.setState({ addModal: !addModal });
    }

    onSelectUser(userId = null) {
        this.setState({ selectedUser: null });
        setImmediate(() => {
            this.setState({ selectedUser: userId });
        });
    }

    onDeleteConfirm(userId) {
        const { selectedUser } = this.state;
        console.log(this.state);
        console.log(this.props);

        this.props.userDelete(userId).then(
            (res) => {
                if (userId === selectedUser) {
                    this.setState({ selectedUser: null });
                }
                this.props.userList();
            },
            (err) => {
                this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` });
            }
        );
    }


    constructSchoolOptions = () => {
        const schoolList = this.state.schoolListData;
        if (schoolList) {
            return schoolList.results.map((item, i) => <Select.Option value={item._id}>{item.name_tc || item.name_en}</Select.Option>);
        }
    }

    onChangeSelectAll = (e) => {
        console.log(`selected ${e.target.checked}`);
    };

    // onChange = (value) => {
    //     console.log(`selected ${value}`);
    //     this.getAverageScore(value);
    // }

    onCheckboxChange = selection => {
        console.log(selection);
        this.setState({ selectedSchool: selection });
    };

    onCheckboxChangeSchoolYear = selection => {
        console.log(selection);
        this.setState({ selectedSchoolYear: selection });
    }

    onCheckboxChangeClassName = selection => {
        console.log(selection);
        this.setState({ selectedClassName: selection });
    }

    onClickReload = () => {
        var queryString = "";
        var queryString1 = "";
        var queryString2 = "";
        var school = "";
        var year = "";
        var name = "";
        var all = false;
        this.setState({ isLoading: true })
        for (var i = 0; i < this.state.selectedSchool.length; i++) {
            for (var j = 0; j < this.state.schoolNameListData.length; j++) {
                if (this.state.selectedSchool[i] === this.state.schoolNameListData[j]) {
                    console.log(this.state.selectedSchool[i], this.state.schoolIdListData[j], i, j);
                    school += " | " + this.state.selectedSchool[i];
                    if (this.state.schoolIdListData[j] === "-1") {
                        all = true;
                    }
                    if (queryString.length === 0) {
                        queryString += this.state.schoolIdListData[j];
                    } else {
                        queryString += "," + this.state.schoolIdListData[j];
                    }
                }
            }
        }
        for (var i = 0; i < this.state.selectedSchoolYear.length; i++) {
            year += " | " + this.state.selectedSchoolYear[i];
            if (queryString1.length === 0) {
                queryString1 += this.state.selectedSchoolYear[i];
            } else {
                queryString1 += "," + this.state.selectedSchoolYear[i];
            }
        }

        for (var i = 0; i < this.state.selectedClassName.length; i++) {
            name += " | " + this.state.selectedClassName[i];
            if (queryString2.length === 0) {
                queryString2 += this.state.selectedClassName[i];
            } else {
                queryString2 += "," + this.state.selectedClassName[i];
            }
        }

        this.setState({
            selectedSchoolString: school,
            selectedYearString: year,
            selectedClassString: name
        })
        all ? this.getAverageScore("", "", "") : this.getAverageScore(queryString, queryString1, queryString2);
    }

    render() {
        return (
            <Animated animationIn="fadeIn">
                <div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
                    <Card title={<p><span>大數據分析</span></p>}>

                        <Row>
                            <Input.Group compact>
                                <CheckboxMenu
                                    options={this.state.schoolNameListData}
                                    value={[]}
                                    onChange={this.onCheckboxChange}
                                    name="選擇學校"
                                    colSpan={12}
                                />

                                <CheckboxMenu
                                    options={this.state.schoolYearList}
                                    value={[]}
                                    onChange={this.onCheckboxChangeSchoolYear}
                                    name="選擇年度"
                                    colSpan={24}
                                />

                                <CheckboxMenu
                                    options={this.state.classNameList}
                                    value={[]}
                                    onChange={this.onCheckboxChangeClassName}
                                    name="選擇班別"
                                    colSpan={12}
                                />

                                <Button onClick={this.onClickReload}>Reload</Button>
                                <Spin tip="Loading..." style={{
                                    visibility: this.state.isLoading ? "visible" : "hidden",
                                    margin: "10px"
                                }}>
                                </Spin>
                            </Input.Group>
                        </Row>

                        <Row>
                            <Col span={8}>
                                <p style={{ textAlign: 'left' }}>總問卷數: {this.state.totalCount}</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <p style={{ textAlign: 'left' }}> {this.state.selectedSchoolString}</p>
                            </Col>
                        </Row>


                        <Row>
                            <Col span={24}>
                                <p style={{ textAlign: 'left' }}> {this.state.selectedYearString}</p>
                            </Col>
                        </Row>


                        <Row>
                            <Col span={24}>
                                <p style={{ textAlign: 'left' }}> {this.state.selectedClassString}</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={4}>
                                <p style={{ textAlign: 'center' }}>實際型 平均: {this.state.avgRScore}</p>
                            </Col>

                            <Col span={4}>
                                <p style={{ textAlign: 'center' }}>探究型 平均: {this.state.avgIScore}</p>
                            </Col>

                            <Col span={4}>
                                <p style={{ textAlign: 'center' }}>藝術型 平均: {this.state.avgAScore}</p>
                            </Col>

                            <Col span={4}>
                                <p style={{ textAlign: 'center' }}>社交型 平均: {this.state.avgSScore}</p>
                            </Col>

                            <Col span={4}>
                                <p style={{ textAlign: 'center' }}>企業型 平均: {this.state.avgEScore}</p>
                            </Col>

                            <Col span={4}>
                                <p style={{ textAlign: 'center' }}>常規型 平均: {this.state.avgCScore}</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>實際型</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>探究型</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>M: {this.state.RMaleCount} F: {this.state.RFemaleCount}</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>M: {this.state.IMaleCount} F: {this.state.IFemaleCount}</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <div className="pieChart" style={{ height: "300px" }}>
                                    {<ResponsivePie
                                        data={this.state.pieRData}
                                        margin={{ top: 40, right: 30, bottom: 120, left: 30 }}
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={1}
                                        colors={["#546FE0", "#D454E0"]}
                                        borderWidth={0}
                                        radialLabelsSkipAngle={10}
                                        radialLabelsTextColor="#000000"
                                        radialLabelsLinkColor={{ from: 'color' }}
                                        sliceLabelsSkipAngle={10}
                                        sliceLabelsTextColor="#000000"
                                    />
                                    }
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="pieChart" style={{ height: "300px" }}>
                                    {<ResponsivePie
                                        data={this.state.pieIData}
                                        margin={{ top: 40, right: 30, bottom: 120, left: 30 }}
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={1}
                                        colors={["#546FE0", "#D454E0"]}
                                        borderWidth={0}
                                        radialLabelsSkipAngle={10}
                                        radialLabelsTextColor="#000000"
                                        radialLabelsLinkColor={{ from: 'color' }}
                                        sliceLabelsSkipAngle={10}
                                        sliceLabelsTextColor="#000000"
                                    />
                                    }
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>藝術型</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>社交型</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>M: {this.state.AMaleCount} F: {this.state.AFemaleCount}</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>M: {this.state.SMaleCount} F: {this.state.SFemaleCount}</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <div className="pieChart" style={{ height: "300px" }}>
                                    {<ResponsivePie
                                        data={this.state.pieAData}
                                        margin={{ top: 40, right: 30, bottom: 120, left: 30 }}
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={1}
                                        colors={["#546FE0", "#D454E0"]}
                                        borderWidth={0}
                                        radialLabelsSkipAngle={10}
                                        radialLabelsTextColor="#000000"
                                        radialLabelsLinkColor={{ from: 'color' }}
                                        sliceLabelsSkipAngle={10}
                                        sliceLabelsTextColor="#000000"
                                    />
                                    }
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="pieChart" style={{ height: "300px" }}>
                                    {<ResponsivePie
                                        data={this.state.pieSData}
                                        margin={{ top: 40, right: 30, bottom: 120, left: 30 }}
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={1}
                                        colors={["#546FE0", "#D454E0"]}
                                        borderWidth={0}
                                        radialLabelsSkipAngle={10}
                                        radialLabelsTextColor="#000000"
                                        radialLabelsLinkColor={{ from: 'color' }}
                                        sliceLabelsSkipAngle={10}
                                        sliceLabelsTextColor="#000000"
                                    />
                                    }
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>企業型</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>常規型</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>M: {this.state.EMaleCount} F: {this.state.EFemaleCount}</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ textAlign: 'center' }}>M: {this.state.CMaleCount} F: {this.state.CFemaleCount}</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <div className="pieChart" style={{ height: "300px" }}>
                                    {<ResponsivePie
                                        data={this.state.pieEData}
                                        margin={{ top: 40, right: 30, bottom: 120, left: 30 }}
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={1}
                                        colors={["#546FE0", "#D454E0"]}
                                        borderWidth={0}
                                        radialLabelsSkipAngle={10}
                                        radialLabelsTextColor="#000000"
                                        radialLabelsLinkColor={{ from: 'color' }}
                                        sliceLabelsSkipAngle={10}
                                        sliceLabelsTextColor="#000000"
                                    />
                                    }
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="pieChart" style={{ height: "300px" }}>
                                    {<ResponsivePie
                                        data={this.state.pieCData}
                                        margin={{ top: 40, right: 30, bottom: 120, left: 30 }}
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={1}
                                        colors={["#546FE0", "#D454E0"]}
                                        borderWidth={0}
                                        radialLabelsSkipAngle={10}
                                        radialLabelsTextColor="#000000"
                                        radialLabelsLinkColor={{ from: 'color' }}
                                        sliceLabelsSkipAngle={10}
                                        sliceLabelsTextColor="#000000"
                                    />
                                    }
                                </div>
                            </Col>
                        </Row>

                    </Card>
                </div>
            </Animated >
        );
    }
}

const mapStateToProps = state => ({
    router: state.router,
    userData: state.user.userData,
    schoolListData: state.school.data,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            userList,
            userDelete,
            schoolList,
            averageScore,
            groupList,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DataHome);